import { render, staticRenderFns } from "./imageViewer.vue?vue&type=template&id=d6a81d10&scoped=true"
import script from "./imageViewer.vue?vue&type=script&lang=js"
export * from "./imageViewer.vue?vue&type=script&lang=js"
import style0 from "./imageViewer.vue?vue&type=style&index=0&id=d6a81d10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6a81d10",
  null
  
)

export default component.exports